const wrapperModules = ['checkout', 'property-explorer', 'engager'] as const;
export type WrapperModule = (typeof wrapperModules)[number];
export const getModuleFromHost = (host: string): WrapperModule | undefined =>
  wrapperModules.find((module) => host.startsWith(module));
